import { ALLBLOGS, AUTHOR, CATEGORY, QUERY } from "../actionTypes/actionTypes"

export const allBlogs=()=>{
    return {
        type:ALLBLOGS
    }
}

export const filerCategory=(category)=>{
    return {
        type:CATEGORY,
        payload:category
    }
}

export const authorBlog=(author)=>{
    return {
        type:AUTHOR,
        payload:author
    }
}

export const searchQuery=(query)=>{
    return {
        type:QUERY,
        payload:query
    }
}